module.exports = __webpack_public_path__ + "img/palm-hotel.8807c678.jpg";